var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiceBackgroundD20Blank(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 5.19615L88.1673 23.7679C91.2613 25.5543 93.1673 28.8555 93.1673 32.4282V69.5718C93.1673 73.1445 91.2613 76.4457 88.1673 78.232L56 96.8038C52.906 98.5902 49.094 98.5902 46 96.8038L13.8327 78.232C10.7387 76.4457 8.8327 73.1445 8.8327 69.5718V32.4282C8.8327 28.8555 10.7387 25.5543 13.8327 23.768L46 5.19615C49.094 3.40983 52.906 3.40982 56 5.19615Z",
    fill: "#EAF0FF",
    stroke: "#363636",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7048 19.9542L51 17.1751L49.2952 19.9542L19.8503 67.9542L17.9819 71H21.5551H80.4449H84.0181L82.1497 67.9542L52.7048 19.9542Z",
    stroke: "#363636",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 71,
    x2: 92,
    y2: 71,
    stroke: "#363636",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.42122,
    y1: 28.0856,
    x2: 52.4212,
    y2: 15.0856,
    stroke: "#363636",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18.2438,
    y1: 70.4338,
    x2: 52.2438,
    y2: 97.4338,
    stroke: "#363636",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 19.0444,
    y1: 70.4191,
    x2: 10.0444,
    y2: 28.4191,
    stroke: "#363636",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 84.0353,
    y1: 69.6258,
    x2: 92.0353,
    y2: 27.6258,
    stroke: "#363636",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 84.2216,
    y1: 70.5836,
    x2: 49.2216,
    y2: 97.5836,
    stroke: "#363636",
    strokeWidth: 4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 51,
    y1: 4,
    x2: 51,
    y2: 17,
    stroke: "#363636",
    strokeWidth: 4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 92.4086,
    y1: 27.9106,
    x2: 50.4086,
    y2: 14.9106,
    stroke: "#363636",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceBackgroundD20Blank);
export default __webpack_public_path__ + "static/media/DiceBackground_D20_Blank.57bda24edc80dcea92aefab9dc0be179.svg";
export { ForwardRef as ReactComponent };